export const invertParserError = e => {
	const t = [e]
	for (let d = e.child; void 0 !== d; d = d.child) t.push(d)
	for (let e = t.length - 2; e >= 0; e--) t[e + 1].child = t.at(e)
	return delete t[0].child, t.at(-1)
}
export const deleteUndefinedValues = e => {
	switch (e.type) {
		case 'query-list':
			for (const t of e.mediaQueries) deleteUndefinedValues(t)
			return e
		case 'query':
			return (
				void 0 === e.prefix && delete e.prefix,
				void 0 === e.mediaType && delete e.mediaType,
				void 0 === e.mediaCondition
					? delete e.mediaCondition
					: deleteUndefinedValues(e.mediaCondition),
				e
			)
		case 'condition':
			void 0 === e.operator && delete e.operator
			for (const t of e.children) deleteUndefinedValues(t)
			return e
		case 'feature':
			return (
				'value' === e.context
					? (void 0 === e.prefix && delete e.prefix, deleteUndefinedValues(e.value))
					: 'range' === e.context &&
					  (void 0 === e.range.leftOp && delete e.range.leftOp,
					  void 0 === e.range.rightOp && delete e.range.rightOp,
					  void 0 === e.range.leftToken
							? delete e.range.leftToken
							: deleteUndefinedValues(e.range.leftToken),
					  void 0 === e.range.rightToken
							? delete e.range.rightToken
							: deleteUndefinedValues(e.range.rightToken)),
				e
			)
		default:
			return e
	}
}
